
import React from 'react';
import PageHeading from './PageHeading';

// Operations page header row: the page name (its h1 since v1.3 ticket 11, RCMC-08) and the page's controls
const PageHeader = props => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems:"center",paddingInline:"10px" }}>
        <PageHeading icon={props.icon} style={{color:"#18283b"}}>{props.title}</PageHeading>
        {props.children}
    </div>
  )
}

export default PageHeader
